import type { DiscoveryFilters, PaginationState } from "@/marketing/models/influencer";

export const INFLUENCER_KEYS = {
  all: ["influencers"] as const,
  search: (filters: DiscoveryFilters, pagination: PaginationState) =>
    [...INFLUENCER_KEYS.all, "search", { filters, pagination }] as const,
  byIds: (ids: string[]) => [...INFLUENCER_KEYS.all, "byIds", ids] as const,
  detail: (id: string) => [...INFLUENCER_KEYS.all, "detail", id] as const,
  lists: () => ["influencer-lists"] as const,
  listMembers: (listId: string) =>
    ["influencer-lists", listId, "members"] as const,
  listMembersPage: (listId: string, offset: number, limit: number) =>
    ["influencer-lists", listId, "members", { offset, limit }] as const,
} as const;
